import { TenantInvoiceAddress } from "../tenantInvoiceAddress/tenantInvoiceAddress";
import { TenantLicenceRequest } from "../tenantLicenceRequest/tenantLicenceRequest";

export class Tenant {
  id: string | undefined;
  name: string| undefined;
  tenantId: string | undefined;
  additionalName: string| undefined;
  email:  string| undefined;
  description:  string| undefined;
  country:  string| undefined;
  addressLine0:  string| undefined;
  addressLine1:  string| undefined;
  postalCode:  string| undefined;
  city:  string| undefined;
  vatType: VatType| undefined;
  vatNumber:  string| undefined;
  phone:  string| undefined;
  hasOpenLicenceRequests: boolean| undefined;
  licenceRequests: TenantLicenceRequest[];
  paymentProviderId: string | undefined;
  paymentProviderEnabled: boolean| undefined;
  invoiceEmail: string | undefined;
  invoiceAddress: TenantInvoiceAddress | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload?.id;
      this.name = payload?.name;
      this.tenantId = payload?.tenantId;
      this.additionalName = payload?.additionalName;
      this.email = payload?.email;
      this.description = payload?.description;
      this.country = payload?.country;
      this.addressLine0 = payload?.addressLine0;
      this.addressLine1 = payload?.addressLine1;
      this.postalCode = payload?.postalCode;
      this.city = payload?.city;
      this.vatNumber = payload?.vatNumber;
      this.vatType = payload?.vatType;
      this.phone = payload?.phone;
      this.hasOpenLicenceRequests = payload?.hasOpenLicenceRequests;
      if (payload?.licenceRequests) {
        this.licenceRequests = TenantLicenceRequest.createTenantLicenceRequests(payload.licenceRequests)
      }
      this.paymentProviderId = payload?.paymentProviderId;
      // workaround as long as backen returns
      // - true for enabled
      // - null for disabled
      if(payload?.paymentProviderEnabled === null || payload?.paymentProviderEnabled === false){
        this.paymentProviderEnabled = false;
      }
      if(payload?.paymentProviderEnabled === true){
        this.paymentProviderEnabled = true;
      }
      this.invoiceEmail = payload?.invoiceEmail;
      if(payload?.invoiceAddress){
        this.invoiceAddress = new TenantInvoiceAddress(payload.invoiceAddress);
      }
    }
  }
}

export class TenantInput {
  id: string | undefined;
  name: string| undefined;
  additionalName: string| undefined;
  email:  string| undefined;
  description:  string| undefined;
  country:  string| undefined;
  addressLine0:  string| undefined;
  addressLine1:  string| undefined;
  postalCode:  string| undefined;
  city:  string| undefined;
  vatNumber:  string| undefined;
  vatType: VatType| undefined;
  phone:  string| undefined;
  paymentProviderId: string | undefined;
  paymentEnabled: boolean| undefined;
  invoiceEmail: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload?.id;
      this.name = payload?.name;
      this.additionalName = payload?.additionalName;
      this.email = payload?.email;
      this.description = payload?.description;
      this.country = payload?.country;
      this.addressLine0 = payload?.addressLine0;
      this.addressLine1 = payload?.addressLine1;
      this.postalCode = payload?.postalCode;
      this.city = payload?.city;
      this.vatNumber = payload?.vatNumber;
      this.vatType = payload?.vatType;
      this.phone = payload?.phone;
      this.paymentProviderId = payload?.paymentProviderId;
      this.paymentEnabled =  payload?.paymentProviderEnabled ? payload?.paymentProviderEnabled : payload?.paymentEnabled;
      this.invoiceEmail = payload?.invoiceEmail;
    }
  }
}

export enum VatType {
  CH_UID, CH_VAT, DE_STN, EU_VAT
}
